import React from 'react';
import styles from './FilterBadges.module.css';

const SALES_PERSONS = {
  '21': 'Aditya Deshpande',
  '22': 'Ashish Tripathi',
  '20': 'Ashwani Sharma',
  '1': 'Bhavani Shanker',
  '6': 'Christy Samuel',
  '12': 'Dr. Prashant Kadam',
  '18': 'Hemanth V',
  '3': 'J Dinesh kumar',
  '13': 'Jagadish Naidu M',
  '14': 'Kamal Kurra',
  '8': 'Mahesh Shegar',
  '11': 'Maneesh S',
  '-1': '-No Sales Employee-',
  '7': 'Pratik Patil',
  '17': 'Pratiksha Dabhane',
  '16': 'R Kalyan Babu',
  '10': 'Raghu B',
  '2': 'RAMAKRISHNAN SUNDARAM',
  '15': 'Ravindra Patil',
  '5': 'Saroj Kumar Purohit',
  '4': 'Satish Nagaraj',
  '9': 'Shafique',
};

const FilterBadges = ({
  selectedYear,
  selectedSalesPerson,
  selectedRegion,
  selectedState,
}) => {
  if (!selectedSalesPerson && !selectedRegion && !selectedState) {
    return null;
  }

  return (
    <div className={styles.badgesContainer}>
      <div className={styles.badgesWrapper}>
        <span className={styles.badgesLabel}>Active Filters:</span>

        {/* Financial Year Badge */}
        <div className={`${styles.badge} ${styles.badgeYear}`}>
          {selectedYear}
        </div>

        {/* Sales Person Badge */}
        {selectedSalesPerson && (
          <div className={`${styles.badge} ${styles.badgeSales}`}>
            {SALES_PERSONS[selectedSalesPerson] || selectedSalesPerson}
          </div>
        )}

        {/* Region Badge */}
        {selectedRegion && (
          <div className={`${styles.badge} ${styles.badgeRegion}`}>
            {selectedRegion}
          </div>
        )}

        {/* State Badge */}
        {selectedState && (
          <div className={`${styles.badge} ${styles.badgeState}`}>
            {selectedState}
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterBadges;